const init = () => {
  const introThumbElms = document.querySelectorAll('.js-introThumb');
  if(introThumbElms.length) {
    introThumbElms.forEach(elm => {
      const thumbFrames = elm.querySelectorAll('picture');
      let isLater = elm.getAttribute('data-later') === 'true' ? 2000 : 0;
      // 2秒ごとにthumbFramesを順番にアニメーションさせる
      let currentIndex = 0;
      setInterval(() => {
        thumbFrames.forEach((frame, index) => {
          if(index === currentIndex) {
            frame.classList.remove('is-visible');
          } else {
            frame.classList.add('is-visible');
          }
        });
        currentIndex = (currentIndex + 1) % thumbFrames.length;
      }, 2000);
    });
  }
}

export {
  init
}
